import * as React from 'react';
import Translation from '../components/UI/Translation';

import { SpanTitle } from '../styles/sharedUIElemStyles';

/* Kolumny dla tabeli "Raporty" */
export const protocolsColumns = [
  {
    title: <Translation id='PRZYDZIAL_LIST_PRZEDMIOTFORMANAZWA' />,
    dataIndex: 'przedmiotNazwa',
    key: 'przedmiotFormaNazwa',
  },
  {
    title: <Translation id='PRZYDZIAL_LIST_PRZEDMIOTFORMAKODLISTA' />,
    dataIndex: 'kodPrzedmiotu',
    key: 'kodPrzedmiotu',
  },
  {
    title: <Translation id='PRZYDZIAL_WYDZIALZLECAJACYNAZWA' />,
    dataIndex: 'nazwaWydzialu',
    key: 'wydzial',
  },
  {
    title: <Translation id='GENERATE_PROTOCOL_MODAL_GENERATE_DATE' />,
    dataIndex: 'dataWygenerowania',
    key: 'dataWygenerowania',
  },
  {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
  },
];

/* Kolumny dla tabeli "Efekty uczenia się" */
export const effectsColumns = [
  {
    title: <Translation id='PAIR_EFFECTS_MODAL_EFFECT_DESCRIPTION' />,
    dataIndex: 'opisEfektuKierunkowego',
    key: 'opisEfektuKierunkowego',
    width: '65%',
  },
  {
    title: <Translation id='PAIR_EFFECTS_MODAL_EFFECT_CODE' />,
    dataIndex: 'efektKierunkuKod',
    key: 'efektKierunkuKod',
    width: '25%',
  },
];
/* Kolumny dla tabel inline'owych w formularzu karty przedmiotu */
export const inlineTableColumns = [
  {
    title: <Translation id='LP' />,
    dataIndex: 'lp',
    width: '10%',
    editable: false,
    type: 'text',
  },
  {
    title: <Translation id='ID' />,
    dataIndex: 'id',
    width: '15%',
    editable: false,
    type: 'text',
  },
  {
    title: <Translation id='TABLE_HEADER_DESCRIPTION' />,
    dataIndex: 'desc',
    width: '60%',
    editable: true,
    type: 'textInput',
  },
];
/* Kolumny dla tabeli "Bilans Godzin" w formularzu karty przedmiotu */
export const hoursBilanceColumns = [
  {
    title: <Translation id='TABLE_HEADER_DESCRIPTION' />,
    dataIndex: 'bilansOpis',
    width: '40%',
    editable: true,
    type: 'textInput',
  },
  {
    title: (
      <span>
        <Translation id='TABLE_HEADER_DESCRIPTION' /> (ENG)
      </span>
    ),
    dataIndex: 'bilansOpisEN',
    width: '40%',
    editable: true,
    type: 'textInput',
  },
  {
    title: <Translation id='HOURS_AMOUNT' />,
    dataIndex: 'bilansGodz',
    width: '10%',
    editable: true,
    type: 'number',
  },
];
/* Kolumny dla tabeli "Formy Zajęć" w formularzu karty przedmiotu */
export const formyZajecColumns = [
  {
    title: <Translation id='FORMY_ZAJEC_NAZWA' />,
    dataIndex: 'formaZajec',
    editable: false,
    type: 'text',
    width: '15%',
  },
  {
    title: <Translation id='FORMY_ZAJEC_GODZ_KONT' />,
    dataIndex: 'godzKont',
    editable: true,
    type: 'number',
    width: '25%',
  },
  {
    title: <Translation id='FORMY_ZAJEC_E_LEARNING' />,
    dataIndex: 'elearning',
    editable: true,
    type: 'checkbox',
    width: '25%',
  },
  {
    title: <Translation id='FORMY_ZAJEC_UDZIAL_WAGOWY' />,
    dataIndex: 'udzialWagowy',
    editable: true,
    type: 'percent',
    width: '25%',
  },
];
/* Kolumny dla tabeli "Realizatorzy Przedmiotu" w formularzu karty przedmiotu */
export const realizatorzyColumns = [
  {
    title: <Translation id='TABLE_HEADER_FIRSTNAME' />,
    dataIndex: 'prowadzacyImie',
    editable: false,
    type: 'text',
    width: '15%',
  },
  {
    title: <Translation id='TABLE_HEADER_LASTNAME' />,
    dataIndex: 'prowadzacyNazwisko',
    editable: false,
    type: 'text',
    width: '15%',
  },
  {
    title: <Translation id='ID' />,
    dataIndex: 'prowadzacyPId',
    editable: false,
    type: 'text',
    width: '15%',
  },
];
export const printStudentsListColumns = [
  {
    title: <Translation id='STUDENT_STUDENTNAZWISKO' />,
    dataIndex: 'studentNazwisko',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTIMIE' />,
    dataIndex: 'studentImie',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTALBUM' />,
    dataIndex: 'studentAlbum',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_SEMESTRAKADEMICKI' />,
    dataIndex: 'semestrAkademicki',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_ROKAKADEMICKI' />,
    dataIndex: 'rokAkademicki',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='GRUPA_DZIEKANSKA' />,
    dataIndex: 'grupaDziekanska',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTWYDZIAL' />,
    dataIndex: 'studentWydzial',
    type: 'text',
    align: 'center',
  },
];

export const printAttendanceListColumns = [
  {
    title: <Translation id='STUDENT_STUDENTNAZWISKO' />,
    dataIndex: 'studentNazwisko',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTIMIE' />,
    dataIndex: 'studentImie',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTALBUM' />,
    dataIndex: 'studentAlbum',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='GRUPA_DZIEKANSKA' />,
    dataIndex: 'grupaDziekanska',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='ACTIVITY_NUMBER' />,
    align: 'center',
    children: [
      {
        title: <SpanTitle width={20} value='1' />,
        dataIndex: 'activity_1',
        type: 'text',
        align: 'center',
        children: [
          {
            title: <br />,
            dataIndex: 'date_activity_1',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='2' />,
        dataIndex: 'activity_2',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_2',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='3' />,
        dataIndex: 'activity_3',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_3',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='4' />,
        dataIndex: 'activity_4',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_4',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='5' />,
        dataIndex: 'activity_5',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_5',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='6' />,
        dataIndex: 'activity_6',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_6',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='7' />,
        dataIndex: 'activity_7',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_7',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='8' />,
        dataIndex: 'activity_8',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_8',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='9' />,
        dataIndex: 'activity_9',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_9',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='10' />,
        dataIndex: 'activity_10',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_10',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='11' />,
        dataIndex: 'activity_11',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_11',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='12' />,
        dataIndex: 'activity_12',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_12',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='13' />,
        dataIndex: 'activity_13',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_13',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='14' />,
        dataIndex: 'activity_14',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_14',
            type: 'text',
            align: 'center',
          },
        ],
      },
      {
        title: <SpanTitle width={20} value='15' />,
        dataIndex: 'activity_15',
        type: 'text',
        align: 'center',
        children: [
          {
            dataIndex: 'date_activity_15',
            type: 'text',
            align: 'center',
          },
        ],
      },
    ],
  },
];

export const studentListWithMarksColumns = [
  {
    title: <Translation id='STUDENT_STUDENTNAZWISKO' />,
    dataIndex: 'studentNazwisko',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTIMIE' />,
    dataIndex: 'studentImie',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_STUDENTALBUM' />,
    dataIndex: 'studentAlbum',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='GRUPA_DZIEKANSKA' />,
    dataIndex: 'grupaDziekanska',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_FORMYZAJEC' />,
    type: 'text',
    dataIndex: 'x',
    align: 'center',
    children: [] as any,
  },
  {
    title: <Translation id='STUDENT_OCENAWYLICZONA' />,
    dataIndex: 'ocenaWyliczona',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='STUDENT_OCENAKONCOWA' />,
    dataIndex: 'ocenaKoncowaText',
    type: 'text',
    align: 'center',
  },
];

export const subjectForStudentListColumns = [
  {
    title: <Translation id='PRZYDZIAL_WYDZIALZLECAJACYKOD' />,
    dataIndex: 'wydzialZlecajacyKod',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='PRZYDZIAL_WYDZIALZLECAJACYNAZWA' />,
    dataIndex: 'wydzialZlecajacyNazwa',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='PRZYDZIAL_PRZEDMIOTNAZWA' />,
    dataIndex: 'przedmiotNazwa',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='PRZYDZIAL_PRZEDMIOTKOD' />,
    dataIndex: 'przedmiotKod',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='PRZYDZIAL_PRZEDMIOTID' />,
    dataIndex: 'przedmiotId',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='PRZYDZIAL_ROKAKADEMICKI' />,
    dataIndex: 'rokAkademicki',
    type: 'text',
    align: 'center',
  },
  {
    title: <Translation id='PRZYDZIAL_SEMESTRAKADEMICKI' />,
    dataIndex: 'semestrAkademicki',
    type: 'text',
    align: 'center',
  },
];
